module.exports = __webpack_public_path__ + "static/media/gssoc.c7f457b8.jpg";